/**
 * Persist a one-shot action across OAuth redirect (Google/Apple leave the page).
 * Cleared on consume so Strict Mode double-mount doesn't double-fire if callers
 * also gate on state.
 */
const KEY = "ln_pending_auth_action_v1";

export function stashPendingAuthAction(action) {
  if (!action || typeof action !== "object") return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify(action));
  } catch {
    /* private mode / quota */
  }
}

export function peekPendingAuthAction() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function consumePendingAuthAction(expectedType = null) {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const action = JSON.parse(raw);
    if (expectedType && action?.type !== expectedType) return null;
    sessionStorage.removeItem(KEY);
    return action;
  } catch {
    try {
      sessionStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
    return null;
  }
}

export function clearPendingAuthAction() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
